import { useSeoMeta } from '@unhead/react';

// FIXME: Update this page (the content is just a fallback if you fail to update the page)

const Index = () => {
  useSeoMeta({
    title: 'Welcome to Your Blank App',
    description: 'A modern Nostr client application built with React, TailwindCSS, and Nostrify.',
  });

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 dark:bg-gray-900">
      <div className="text-center">
        <h1 className="text-4xl font-bold mb-4 text-gray-900 dark:text-gray-100">
          Live Translator for Minibus Tours
        </h1>
        <p className="text-xl text-gray-600 dark:text-gray-400 mb-8">
          Real-time voice translation from English to multiple languages.
        </p>
        <a
          href="/translator"
          className="inline-flex items-center justify-center px-6 py-3 bg-blue-600 hover:bg-blue-700 rounded-lg text-white font-semibold transition-colors"
        >
          Start Translator
        </a>
      </div>
    </div>
  );
};

export default Index;
